import {
  completeVaccineTask,
  listVaccineTasks,
  listVaccineTasksByProjectType,
  nextVaccineTask,
  markVaccineTaskGiven,
  markVaccineTasksGiven,
  skipVaccineTask,
  skipVaccineTasks,
} from "./vaccineService";
import feedingService from "./feedingService";
import medicineService from "./medicineService";

const removedFeedingGeneration = async () => {
  throw new Error("Manual feeding task generation was removed. Active feeding rules auto-create daily tasks from their start date.");
};

const taskService = {
  // -------- Vaccine --------
  listVaccineTasks,
  listVaccineTasksByProjectType,
  nextVaccineTask,
  completeVaccineTask,
  markVaccineTaskGiven,
  markVaccineTasksGiven,
  skipVaccineTask,
  skipVaccineTasks,

  // -------- Feeding --------
  previewFeedingGeneration: removedFeedingGeneration,
  generateFeedingTasks: removedFeedingGeneration,
  generateFeedingTasksForBatch: removedFeedingGeneration,
  listFeedingTasks: async (filters = {}) => feedingService.listTasks(filters),
  decideFeedingTask: async (taskId, payload) => feedingService.decideTask(taskId, payload),
  syncFeedingTasks: async (date) => feedingService.syncTasks(date),
  completeFeedingTasksBulk: async (items) => feedingService.completeTasksBulk(items),
  decideFeedingTasksBulk: async (taskIds,action) => feedingService.bulkDecision(taskIds,action),
  listFeedingLogs: async (batchId, opts = {}) => feedingService.listLogs(batchId, opts),

  // -------- Medicine --------
  previewMedicineGeneration: async (filters = {}) =>
    medicineService.generateMedicineTasks({ ...filters, dryRun: true }),
  generateMedicineTasks: async (filters = {}) =>
    medicineService.generateMedicineTasks({ ...filters, dryRun: false }),
  listMedicineTasks: async (filters = {}) => medicineService.listMedicineTasks(filters),
  decideMedicineTask: async (taskId, payload) => medicineService.decideMedicineTask(taskId, payload),
  listMedicineLogs: async (filters = {}) => medicineService.listMedicineLogs(filters),
};

export default taskService;
